// extracted by mini-css-extract-plugin
module.exports = {"staff_page":"staff_staff_page__3Ure9","main_content":"staff_main_content__x0oMz"};